// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
}

:root {
  --primary: black;
}

.container {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0;
  height: auto;
}

body {
  background: #000;
}




@media screen and (max-width: 2000px) {
  .container {
    width: 100%;
    max-width: 2000px;
    margin: 0 auto;
    padding: 0 100px;
  }
}

@media screen and (max-width: 1025px) {
  .container {
    width: 100%;
    max-width: 1025px;
    margin: 0 auto;
    padding: 0 50px;
  }
}

@media screen and (max-width: 960px) {
  .container {
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding: 0 25px;
  }
}

@media screen and (max-width: 400x) {
  .container {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    padding: 0 25px;
  }
}

section {
  height: 90vh;
  width: auto;
}

@media screen and (max-width: 2000px) {
  section {
    height: 90vh;
    width: auto;
  }
}

.btn-gl {
  padding: 8px 20px;
  border-radius: 4px;
  outline: none;
  border-color: white;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  background-color: var(--primary);
}

.btn-dash {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  border-radius: 4px;
  outline: none;
}

.btn-gl:hover {
  background-color: #333;
}

.Service_list {
  padding-top: 5px;
  padding-bottom: 5px;
}

.Text {
  text-align: center;
  padding-top: 50px;
  padding-bottom: 0;
}

.Text h1 {
  font-size: 25px;
  font-weight: 500;
  color: #000;
  padding-bottom: 10px;
}

.Text1 p {
  text-align: center;
}

.Text1, small {
  text-align: center;
}

.Text2 p {
  text-align: center;
  font-weight: 100;
  font-size: small;
}

.Top {
  padding-top: 20px;
}

.Bottom {
  padding-bottom: 20px;
}

.CardContainerTop {
  padding-bottom: 30px;
  padding-top: 30px;
}

.CardContainer {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
}

.CardContainerCenter {
  justify-content: center;
  align-items: center;
}

.CardContainer a {
  color: #000;
}

.CardContainerTitle {
  padding-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.CardContainerTitle1 {
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.infoicon {
  display: flex;
  flex-direction: row-reverse;

}

.form-label {
  display: block;
  margin-bottom: 10px;
}

.form-select,
.form-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  box-sizing: border-box;
  cursor: pointer;
}

input:focus {
  border-color: white;
  box-shadow: 0 0 5px whitesmoke;
}

form {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  background-color: black;
  color: white;
  border-radius: 8px;
}

input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  background: #000;
  border-radius: 4px;
  outline: none;
}

.table-container {
  margin: 0 auto;
}

th,
td {
  text-align: left;
  padding: 8px;
}

th {
  text-align: center;
}


/*Bewertung*/

.star-rating {
  font-size: 24px;
  margin-bottom: 10px;
}

.star {
  display: inline-block;
  color: rgb(0, 0, 0);
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 5px;
  cursor: pointer;
}

.star.selected {
  color: var(--primary);
}

/* Dashboard */

.DashboardBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;;;;AAKA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;;AAE7B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,YAAY;;AAEZ;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Roboto\", sans-serif;\n}\n\n:root {\n  --primary: black;\n}\n\n.container {\n  width: 100%;\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 0;\n  height: auto;\n}\n\nbody {\n  background: #000;\n}\n\n\n\n\n@media screen and (max-width: 2000px) {\n  .container {\n    width: 100%;\n    max-width: 2000px;\n    margin: 0 auto;\n    padding: 0 100px;\n  }\n}\n\n@media screen and (max-width: 1025px) {\n  .container {\n    width: 100%;\n    max-width: 1025px;\n    margin: 0 auto;\n    padding: 0 50px;\n  }\n}\n\n@media screen and (max-width: 960px) {\n  .container {\n    width: 100%;\n    max-width: 960px;\n    margin: 0 auto;\n    padding: 0 25px;\n  }\n}\n\n@media screen and (max-width: 400x) {\n  .container {\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 0 25px;\n  }\n}\n\nsection {\n  height: 90vh;\n  width: auto;\n}\n\n@media screen and (max-width: 2000px) {\n  section {\n    height: 90vh;\n    width: auto;\n  }\n}\n\n.btn-gl {\n  padding: 8px 20px;\n  border-radius: 4px;\n  outline: none;\n  border-color: white;\n  font-size: 18px;\n  color: #fff;\n  cursor: pointer;\n  background-color: var(--primary);\n}\n\n.btn-dash {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 20px;\n  border-radius: 4px;\n  outline: none;\n}\n\n.btn-gl:hover {\n  background-color: #333;\n}\n\n.Service_list {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.Text {\n  text-align: center;\n  padding-top: 50px;\n  padding-bottom: 0;\n}\n\n.Text h1 {\n  font-size: 25px;\n  font-weight: 500;\n  color: #000;\n  padding-bottom: 10px;\n}\n\n.Text1 p {\n  text-align: center;\n}\n\n.Text1, small {\n  text-align: center;\n}\n\n.Text2 p {\n  text-align: center;\n  font-weight: 100;\n  font-size: small;\n}\n\n.Top {\n  padding-top: 20px;\n}\n\n.Bottom {\n  padding-bottom: 20px;\n}\n\n.CardContainerTop {\n  padding-bottom: 30px;\n  padding-top: 30px;\n}\n\n.CardContainer {\n  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 5px;\n  justify-content: center;\n  align-items: center;\n}\n\n.CardContainerCenter {\n  justify-content: center;\n  align-items: center;\n}\n\n.CardContainer a {\n  color: #000;\n}\n\n.CardContainerTitle {\n  padding-bottom: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.CardContainerTitle1 {\n  padding-bottom: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.infoicon {\n  display: flex;\n  flex-direction: row-reverse;\n\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.form-select,\n.form-input {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\ninput:focus {\n  border-color: white;\n  box-shadow: 0 0 5px whitesmoke;\n}\n\nform {\n  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: black;\n  color: white;\n  border-radius: 8px;\n}\n\ninput {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  background: #000;\n  border-radius: 4px;\n  outline: none;\n}\n\n.table-container {\n  margin: 0 auto;\n}\n\nth,\ntd {\n  text-align: left;\n  padding: 8px;\n}\n\nth {\n  text-align: center;\n}\n\n\n/*Bewertung*/\n\n.star-rating {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.star {\n  display: inline-block;\n  color: rgb(0, 0, 0);\n  border: 1px solid rgba(0, 0, 0, 0);\n  padding: 5px;\n  cursor: pointer;\n}\n\n.star.selected {\n  color: var(--primary);\n}\n\n/* Dashboard */\n\n.DashboardBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
